import { useContext } from "react";

import type { SnackbarData } from "./SnackbarContext";
import { SnackbarContext } from "./SnackbarContext";

const useSnackbar = (): SnackbarData => {
  return useContext(SnackbarContext);
};

export { useSnackbar };
